import React, { createContext, Component } from "react";
import ReactAudioPlayer from "react-audio-player";

export const AudioContext = createContext();

class AudioContextProvider extends Component {
  state = {
    volume: 0.3,
  };
  // audio = new Audio(
  //   require(`../assets/audio/bck${
  //     new Date().getTime() % 2 > 0 ? "1" : "2"
  //   }.mp3`)
  // );
  componentDidMount() {
    // this.audio.volume = 0.3;
    // this.audio.loop = true;
    // this.audio.play();
  }
  volumeDown = () => {
    this.setState({ volume: 0.1 });
    // this.audio.volume = 0.1;
  };
  volumeUp = () => {
    this.setState({ volume: 0.3 });
    // this.audio.volume = 0.3;
  };
  // play = () => {
  //   this.audio.play();
  // };
  render() {
    return (
      <AudioContext.Provider
        value={{
          ...this.state,
          // play: this.play,
          volumeDown: this.volumeDown,
          volumeUp: this.volumeUp,
        }}
      >
        <ReactAudioPlayer
          src={require(`../assets/audio/bck${
            new Date().getTime() % 2 > 0 ? "1" : "2"
          }.mp3`)}
          volume={this.state.volume}
          autoPlay
          loop={true}
        />
        {this.props.children}
      </AudioContext.Provider>
    );
  }
}

export default AudioContextProvider;
